import React, {useEffect} from "react"
import {useContentCardActions} from "@irati/braze"
import type {Popup as IPopup} from "@irati/braze"
import FlexiPointsIcon from "@irati/ui/images/flexi_point.svg"
import RewardPointsIcon from "@irati/ui/images/reward_point.svg"
import styled from "styled-components"
import Flex from "../../Flex"
import {ButtonRouterLink} from "../../Link"
import {Body, H2, H3} from "../../Typography"
import {pathToRoute} from "./pathToRoute"

const Image = styled.img`
  margin-right: ${({theme}) => theme.spacing.half};
`

export function Popup({popup, onClick}: {popup: IPopup; onClick: () => void}) {
  const {app, to} = pathToRoute(popup.ctaUrl)
  const parts = popup.subtitle?.split(":") ?? []

  const {markContentCardsImpression} = useContentCardActions()

  useEffect(() => {
    if (popup.hideIf === "viewed") {
      markContentCardsImpression([popup.id])
    }
  }, [])

  return (
    <Flex direction="column" alignItems="center" gap={2}>
      <img src={popup.headerIcon} width="240px" />
      <H2>{popup.title}</H2>
      <H3>
        {parts.map((m, i) => {
          if (m === "RP") return <Image key={i} src={RewardPointsIcon} alt="Flexi Point Icon" />
          if (m === "FP") return <Image key={i} src={FlexiPointsIcon} alt="Flexi Point Icon" />
          return <span key={i}>{m}</span>
        })}
      </H3>
      <img src={popup.icon} />
      <Body textAlign="center" marginBottom={2}>
        {popup.message}
      </Body>
      <ButtonRouterLink primary to={to} app={app} full onClick={onClick}>
        {popup.ctaCopy}
      </ButtonRouterLink>
    </Flex>
  )
}
